import { Typography } from '@mui/material';
import { SxStyle } from '../../types';
import Grid2 from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import React from 'react';
import { useUserAuth } from '../../contexts/auth';
import { useStringsContext } from '../../contexts/strings';
import ScenePage from '../common/scene/scene-page';

const styles: SxStyle = {
  content: {
    marginBottom: 4,
  },
};

function Account() {
  const { currentUser, logout } = useUserAuth();
  const { strings } = useStringsContext();

  return (
    <ScenePage title={strings.appBar.account}>
      <Grid2 direction="column" container spacing={2} sx={styles.content}>
        <Grid2 container spacing={2}>
          <Grid2>
            <Typography variant="bold">{strings.account.email}</Typography>
          </Grid2>
          <Grid2 alignItems="center">
            <Typography>{currentUser?.email}</Typography>
          </Grid2>
        </Grid2>
        <Grid2 container spacing={2}>
          <Grid2>
            <Typography variant="bold">CEE ID</Typography>
          </Grid2>
          <Grid2>
            <Typography alignItems="center">{currentUser?.uid}</Typography>
          </Grid2>
        </Grid2>
      </Grid2>
      <Button onClick={logout} variant="contained" color="primary">
        {strings.actions.logout}
      </Button>
    </ScenePage>
  );
}

export default Account;
